import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import { formatVA } from '../../../../../services/utilityFunctions';
import LevelCard from './LevelCard';

function LevelObjectives({ t, data }) {
  if (!data || data.length === 0) return null;

  // First level that has not been completed is the "current" target level
  const currentIndex = data.findIndex(l => !l.levelCompleted);
  const currentLevel = currentIndex >= 0 ? data[currentIndex] : null;

  return (
    <div className="level-objectives mb-3">
      <div className="level-objectives-header">
        <div className="career-section-title">
          {t('pureliink.career.progression.levels')}
        </div>
      </div>
      <div className="level-objectives-content">
        <div className="level-objectives-labels-table">
          <table
            className="table table-striped m-table my-0"
            style={{ width: '100%' }}
          >
            <tbody>
              <tr className="content">
                <td className="contentCell">
                  {t('pureliink.career.progression.personalVA')}{' '}
                  {currentLevel?.personalVA?.currentValue != null && (
                    <span className="levels-param-current">
                      {formatVA(currentLevel.personalVA.currentValue)} VA
                    </span>
                  )}
                </td>
              </tr>
              <tr className="content">
                <td className="contentCell">
                  {t('pureliink.career.progression.groupVA')}{' '}
                  {currentLevel?.groupVA?.currentValue != null && (
                    <span className="levels-param-current">
                      {formatVA(currentLevel.groupVA.currentValue)} VA
                    </span>
                  )}
                </td>
              </tr>
              <tr className="content">
                <td className="contentCell">
                  {t('pureliink.career.progression.lines')}{' '}
                  {currentLevel?.lines?.topLinesVA?.length > 0 && (
                    <span className="levels-param-current levels-param-current--vertical">
                      {currentLevel.lines.topLinesVA.map(va => (
                        <span key={va}>{formatVA(va)} VA</span>
                      ))}
                    </span>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="level-card-container">
          {data.map((levelData, index) => (
            <LevelCard
              key={levelData.level}
              t={t}
              levelData={levelData}
              isCurrent={index === currentIndex}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

LevelObjectives.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      level: PropTypes.number.isRequired,
      levelCompleted: PropTypes.bool,
    }),
  ).isRequired,
};

export default translate(LevelObjectives);
